export const GVAZ_FOLDER_NAMES = {
  'la-tribu/PlayT/clipping': 'Clipping',
  'la-tribu/RACING-LAB/clipping': 'Clipping',
  'la-tribu/Switch/clipping': 'Clipping'
} as const;
